/*
  © 2024 KondaSoft
  https://www.kondasoft.com
*/

/*
  Header/Navbar
*/
// function initHeaderReveal () {
//   let oldScroll = window.scrollY
//   const headerGroup = document.querySelector('#header-group')

//   window.addEventListener('scroll', () => {
//     const newScroll = window.scrollY
//     if (newScroll > oldScroll) {
//       if (newScroll > headerGroup.clientHeight) {
//         headerGroup.classList.add('hide')
//       }
//     } else if (newScroll < oldScroll) {
//       headerGroup.classList.remove('hide')
//     }

//     oldScroll = Math.max(window.scrollY, 0)
//   })
// }
// initHeaderReveal()

/*
  One page logic
*/
function handleOnePageLogic () {
  if (document.querySelector('.page-type-index')) {
    document.querySelector('#judgeme_product_reviews')?.classList.add('section-anchored')
    document.querySelector('#judgeme_product_reviews')?.setAttribute('id', 'reviews')
  }

  const mobileNavLinks = document.querySelectorAll('#offcanvas-menu .accordion-nav a')
  const desktopNavLinks = document.querySelectorAll('#navbar-desktop a')

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const id = entry.target.getAttribute('id')

      if (entry.isIntersecting) {
        entry.target.classList.add('section-in-view')

        mobileNavLinks.forEach(elem => {
          elem.classList.remove('active')
          if (elem.getAttribute('href').includes(id)) {
            elem.classList.add('active')
          }
        })
        desktopNavLinks.forEach(elem => {
          elem.classList.remove('active')
          if (elem.getAttribute('href').includes(id)) {
            elem.classList.add('active')
          }
        })
      } else {
        entry.target.classList.remove('section-in-view')

        mobileNavLinks.forEach(elem => {
          if (elem.getAttribute('href') === `#${id}`) {
            elem.classList.remove('active')
          }
        })
        desktopNavLinks.forEach(elem => {
          if (elem.getAttribute('href') === `#${id}`) {
            elem.classList.remove('active')
          }
        })
      }
    })
  }, { threshold: 0.25 })

  document.querySelectorAll('.section-anchored').forEach(section => {
    const navbarHeight = document.querySelector('[id*="__navbar"].sticky-top').clientHeight
    section.style.scrollMarginTop = `${navbarHeight}px`

    observer.observe(section)
  })

  mobileNavLinks.forEach((link, index) => {
    link.addEventListener('click', () => {
      if (link.getAttribute('href').includes('#')) {
        mobileNavLinks.forEach(elem => {
          elem.classList.remove('active')
        })
        link.classList.add('active')
      }

      setTimeout(() => {
        window.bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-menu').hide()
      }, 300)
    })
  })

  desktopNavLinks.forEach((link, index) => {
    link.addEventListener('click', () => {
      if (link.getAttribute('href').includes('#')) {
        desktopNavLinks.forEach(elem => {
          elem.classList.remove('active')
        })
        link.classList.add('active')
      }
    })
  })
}
handleOnePageLogic()

/*
  Detect viewport with the Intersection Observer API
*/
const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('viewport-entered')
    } else {
      entry.target.classList.remove('viewport-entered')
    }
  })
}, { threshold: 0.4 })

document.querySelectorAll('.viewport-detect').forEach((el) => {
  observer.observe(el)
})

/*
  Offcanvas menu
*/
// function adjustOffcanvasMenu () {
//   const offcanvasMenu = document.querySelector('#offcanvas-menu')
//   const navbarMobile = document.querySelector('#navbar-mobile')

//   offcanvasMenu?.addEventListener('show.bs.offcanvas', () => {
//     const navbarSpacing = document.querySelector('[id*="__navbar"].sticky-top').getBoundingClientRect().bottom
//     offcanvasMenu.style.height = `${window.innerHeight - navbarSpacing}px`

//     navbarMobile.querySelector('.svg-icon-menu')?.classList.add('svg-icon-menu-close')
//   })

//   offcanvasMenu?.addEventListener('hide.bs.offcanvas', () => {
//     navbarMobile.querySelector('.svg-icon-menu')?.classList.remove('svg-icon-menu-close')
//   })
// }
// adjustOffcanvasMenu()

// document.addEventListener('shopify:section:load', (event) => {
//   if (event.target.querySelector('#offcanvas-menu')) {
//     adjustOffcanvasMenu()
//   }
// })

/*
  Localization form
*/
document.querySelectorAll('.shopify-localization-form button').forEach(btn => {
  btn.addEventListener('click', () => {
    btn.closest('form').querySelector('[name="country_code"]').value = btn.dataset.isoCode
    btn.closest('form').submit()
  })
})

/*
  General Slider
*/
class GeneralSlider extends HTMLElement {
  constructor () {
    super()

    /** @type {Swiper} */
    this.slider = new window.Swiper(this.querySelector('.swiper'), this.splideOptions())
  }

  splideOptions () {
    const partialSlidesMobile = this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1

    /** @type {SwiperOptions} */
    const options = {
      rewind: true,
      speed: Number(this.dataset.sliderSpeed),
      breakpoints: {
        0: { slidesPerView: Number(this.dataset.breakpointXs) * partialSlidesMobile },
        576: { slidesPerView: Number(this.dataset.breakpointSm) },
        768: { slidesPerView: Number(this.dataset.breakpointMd) },
        992: { slidesPerView: Number(this.dataset.breakpointLg) },
        1200: { slidesPerView: Number(this.dataset.breakpointXl) },
        1400: { slidesPerView: Number(this.dataset.breakpointXxl) }
      },
      navigation: {
        enabled: this.dataset.sliderNav === 'true',
        nextEl: this.querySelector('.general-slider-swiper-controls .swiper-button-next'),
        prevEl: this.querySelector('.general-slider-swiper-controls .swiper-button-prev')
      },
      pagination: {
        enabled: this.dataset.sliderPagination === 'true',
        type: this.dataset.sliderPaginationType,
        el: '.swiper-pagination',
        dynamicBullets: true,
        dynamicMainBullets: 2,
        renderFraction: function (currentClass, totalClass) {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
        }
      },
      scrollbar: {
        enabled: this.dataset.sliderScrollbar === 'true',
        el: this.querySelector('.general-slider-swiper-controls .swiper-scrollbar'),
        draggable: true
        // hide: true
      },
      autoplay: this.dataset.sliderAutoplay !== '0'
        ? { delay: Number(this.dataset.sliderAutoplay) * 1000 }
        : undefined
    }
    return options
  }
}
customElements.define('general-slider', GeneralSlider)

/*
  Marquee Slider
*/
class MarqueeSlider extends HTMLElement {
  constructor () {
    super()

    /** @type {Swiper} */
    this.slider = new window.Swiper(this.querySelector('.swiper'), this.splideOptions())
  }

  splideOptions () {
    /** @type {SwiperOptions} */
    const options = {
      centeredSlides: true,
      speed: Number(this.dataset.sliderSpeed) * 1000,
      loop: true,
      slidesPerView: 'auto',
      // grabCursor: true,
      autoplay: {
        delay: 1,
        pauseOnMouseEnter: true
      }
    }
    return options
  }
}
customElements.define('marquee-slider', MarqueeSlider)

/*
  Product Stock Indicator
*/
class ProductStockIndicator extends HTMLElement {
  constructor () {
    super()

    this.progressBar = this.querySelector('.progress-bar')
    this.animateProgressBar()
    this.handleVariantChange()
  }

  animateProgressBar () {
    setTimeout(() => {
      this.progressBar.style.width = this.progressBar.dataset.width
    }, 250)
  }

  handleVariantChange () {
    window.addEventListener('kt.product.variant.change', async (e) => {
      const variant = e.detail

      this.querySelector('.product-block-stock-indicator-inner').style.opacity = '.25'

      const respoonse = await fetch(`${this.dataset.productUrl}?variant=${variant.id}`)
      const text = await respoonse.text()
      const newDocument = new DOMParser().parseFromString(text, 'text/html')

      this.replaceWith(newDocument.querySelector('[id*="product-block-stock-indicator"]'))
      this.animateProgressBar()
    })
  }
}
customElements.define('product-stock-indicator', ProductStockIndicator)

/*
  Animated Countdowns
*/
class AnimatedCountdown extends HTMLElement {
  constructor () {
    super()

    if (!this.dataset.time.length) {
      this.innerHTML = 'Please add the unix time in the settings'
    }

    let countDownDate = Number(this.dataset.time) * 1000

    if (window.location.href.includes('ks-')) {
      countDownDate = Date.now() + 1.728e+8
    }

    const x = setInterval(() => {
      const now = new Date().getTime()
      const distance = countDownDate - now

      const days = Math.floor(distance / (1000 * 60 * 60 * 24))
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      const min = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
      const sec = Math.floor((distance % (1000 * 60)) / 1000)

      this.querySelector('[data-days]').innerHTML = `${days} <em>${this.dataset.textDays}</em>`
      this.querySelector('[data-hours]').innerHTML = `${hours} <em>${this.dataset.textHours}</em>`
      this.querySelector('[data-min]').innerHTML = `${min} <em>${this.dataset.textMin}</em>`
      this.querySelector('[data-sec]').innerHTML = `${sec} <em>${this.dataset.textSec}</em>`

      if (distance < 0) {
        clearInterval(x)
        this.innerHTML = this.dataset.textExpired
      }
    }, 1000)
  }
}
customElements.define('animated-countdown', AnimatedCountdown)
